export default __webpack_public_path__ + "static/media/home-10.2e4dbf1d.png";